import { g as r } from "./global.js";
import { f as t } from "./fails.js";
import { f as o } from "./function-uncurry-this.js";
import { t as s } from "./to-string.js";
import { s as a } from "./string-trim.js";
import { w as i } from "./whitespaces.js";
var m = a.trim,
  f = o("".charAt),
  n = r.parseFloat,
  e = r.Symbol,
  p = e && e.iterator,
  c = 1 / n(i + "-0") != -1 / 0 || p && !t(function () {
    n(Object(p));
  }) ? function (r) {
    var t = m(s(r)),
      o = n(t);
    return 0 === o && "-" == f(t, 0) ? -0 : o;
  } : n;
export { c as n };